export default __webpack_public_path__ + "static/media/keller-devices.88ec43fc.png";